import React, {
  createContext,
  useState,
  useEffect,
  useContext,
  ReactNode,
} from "react";

// Define the shape of the context value
interface LocalStorageContextType {
  propertyId: string | null;
  propertyTitle: string;
  userData: any;
  updateTitle: (title: string) => void;
  updatePropertyId: (newValue: string) => void;
  updateUserData(newValue: any): void;
  reports: {
    linkReportsCount: number;
    apiDocReportsCount: number;
    benchmarkReportsCount: number;
  };

  updateReports: (data: {
    linkReportsCount: number;
    apiDocReportsCount: number;
    benchmarkReportsCount: number;
  }) => void;
}

// Create the context with a default value
// export const LocalStorageContext = {} as LocalStorageContextType;
export const LocalStorageContext = createContext<LocalStorageContextType>(
  {} as LocalStorageContextType,
);
// Create a provider component
interface LocalStorageProviderProps {
  children: ReactNode;
}

export const LocalStorageProvider: React.FC<LocalStorageProviderProps> = ({
  children,
}) => {
  const [propertyId, setPropertyId] = useState<string | null>(null);

  const [propertyTitle, setPropertyTitle] = useState<string>("");
  const [reports, setReports] = useState({
    linkReportsCount: 0,
    apiDocReportsCount: 0,
    benchmarkReportsCount: 0,
  });
  const [userData, setUserData] = useState<any>({});

  useEffect(() => {
    const handleStorageChange = (event: StorageEvent) => {
      if (event.key === "propertyId") {
        // setData(event.newValue);
      }
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  const updatePropertyId = (newValue: string) => {
    // setLocalStorageData("propertyId", newValue);
    setPropertyId(newValue);
  };

  const updateTitle = (title: string) => {
    // setLocalStorageData("propertyId", newValue);
    setPropertyTitle(title);
  };
  const updateUserData = (data: any) => {
    // setLocalStorageData("propertyId", newValue);
    setUserData(data);
  };
  const updateReports = (data: {
    linkReportsCount: number;
    apiDocReportsCount: number;
    benchmarkReportsCount: number;
  }) => {
    setReports(data);
  };
  return (
    <LocalStorageContext.Provider
      value={{
        propertyId,
        updatePropertyId,
        propertyTitle,
        updateTitle,
        userData,
        updateUserData,
        reports,
        updateReports,
      }}
    >
      {children}
    </LocalStorageContext.Provider>
  );
};

export const useLocalStorage = (): LocalStorageContextType => {
  const context = useContext(LocalStorageContext);
  if (!context) {
    throw new Error(
      "useLocalStorage must be used within a LocalStorageProvider",
    );
  }
  return context;
};
